// Ancient Japan Trainers Data - Group One (First 6 Characters)

// Tea Master Sen no Rikyu's workout programs
const teaMasterPrograms = [
    {
        id: 'way-of-tea-balance',
        name: 'Way of Tea Balance',
        description: 'Mindful movement that mirrors the precision and grace of the tea ceremony',
        pattern: 'd_@^wa',
        reps: 7,
        sets: 4,
        focus: 'Mindful Precision'
    },
    {
        id: 'ceremonial-flow-training',
        name: 'Ceremonial Flow Training',
        description: 'Fluid transitions and perfect posture developed through tea ceremony discipline',
        pattern: '_d@wa^',
        reps: 9,
        sets: 3,
        focus: 'Graceful Flow'
    },
    {
        id: 'bamboo-garden-conditioning',
        name: 'Bamboo Garden Conditioning',
        description: 'Natural strength building inspired by the simplicity of zen gardens',
        pattern: 'wa@d_^',
        reps: 11,
        sets: 4,
        focus: 'Natural Harmony'
    },
    {
        id: 'seasonal-meditation-workout',
        name: 'Seasonal Meditation Workout',
        description: 'Training that changes like the seasons, maintaining perfect inner balance',
        pattern: 'd^_@wa',
        reps: 8,
        sets: 5,
        focus: 'Seasonal Adaptation'
    },
    {
        id: 'aesthetic-perfection-protocol',
        name: 'Aesthetic Perfection Protocol',
        description: 'Every movement refined to achieve the beauty found in tea ceremony',
        pattern: '@wd_^a',
        reps: 6,
        sets: 6,
        focus: 'Refined Beauty'
    },
    {
        id: 'master-of-ceremonies-training',
        name: 'Master of Ceremonies Training',
        description: 'The complete discipline that transforms daily practice into artistic mastery',
        pattern: 'wa@d^_!',
        reps: 10,
        sets: 3,
        focus: 'Artistic Mastery'
    }
];

// Kabuki Actor's workout programs
const kabukiActorPrograms = [
    {
        id: 'dramatic-expression-training',
        name: 'Dramatic Expression Training',
        description: 'Build the explosive power needed for theatrical combat and dramatic poses',
        pattern: '^_w@da',
        reps: 13,
        sets: 3,
        focus: 'Theatrical Power'
    },
    {
        id: 'stage-warrior-conditioning',
        name: 'Stage Warrior Conditioning',
        description: 'Athletic preparation for the demanding physicality of kabuki performance',
        pattern: 'w@^_da',
        reps: 15,
        sets: 4,
        focus: 'Performance Endurance'
    },
    {
        id: 'mask-and-movement-workout',
        name: 'Mask and Movement Workout',
        description: 'Training to maintain perfect form while wearing heavy traditional costumes',
        pattern: 'd@wa^_',
        reps: 12,
        sets: 3,
        focus: 'Costume Conditioning'
    },
    {
        id: 'emotional-intensity-protocol',
        name: 'Emotional Intensity Protocol',
        description: 'Channel deep emotions into physical strength for authentic performances',
        pattern: '_^@wda',
        reps: 17,
        sets: 3,
        focus: 'Emotional Power'
    },
    {
        id: 'traditional-dance-strength',
        name: 'Traditional Dance Strength',
        description: 'Build the specific strength needed for traditional Japanese dance movements',
        pattern: 'a@d^w_',
        reps: 14,
        sets: 4,
        focus: 'Dance Athletics'
    },
    {
        id: 'grand-finale-training',
        name: 'Grand Finale Training',
        description: 'Ultimate conditioning for the climactic moments that define great kabuki',
        pattern: 'w@d^_a!',
        reps: 19,
        sets: 3,
        focus: 'Climactic Excellence'
    }
];

// Takeda Shingen's workout programs
const takedaShingenPrograms = [
    {
        id: 'cavalry-commander-training',
        name: 'Cavalry Commander Training',
        description: 'Build the core strength and balance needed to command from horseback',
        pattern: '~^@wd_',
        reps: 16,
        sets: 3,
        focus: 'Mounted Leadership'
    },
    {
        id: 'tiger-of-kai-conditioning',
        name: 'Tiger of Kai Conditioning',
        description: 'Fierce training that embodies the predatory power of the great tiger',
        pattern: '^~@w_d',
        reps: 18,
        sets: 4,
        focus: 'Predatory Power'
    },
    {
        id: 'swift-as-wind-workout',
        name: 'Swift as Wind Workout',
        description: 'Lightning-fast conditioning based on the famous Takeda battle motto',
        pattern: '_w@^~d',
        reps: 22,
        sets: 3,
        focus: 'Lightning Speed'
    },
    {
        id: 'mountain-fortress-strength',
        name: 'Mountain Fortress Strength',
        description: 'Unshakeable foundation training inspired by Takeda mountain strongholds',
        pattern: 'w@~d^_',
        reps: 20,
        sets: 4,
        focus: 'Fortress Foundation'
    },
    {
        id: 'strategic-warfare-protocol',
        name: 'Strategic Warfare Protocol',
        description: 'Multi-faceted training that develops both tactical mind and warrior body',
        pattern: '@^_~wd',
        reps: 15,
        sets: 5,
        focus: 'Tactical Conditioning'
    },
    {
        id: 'legendary-general-training',
        name: 'Legendary General Training',
        description: 'The complete regimen that forged one of Japan\'s greatest military leaders',
        pattern: '~w@d^_!',
        reps: 24,
        sets: 3,
        focus: 'Legendary Leadership'
    }
];

// Hattori Hanzo's workout programs
const hattoriHanzoPrograms = [
    {
        id: 'shadow-stealth-training',
        name: 'Shadow Stealth Training',
        description: 'Silent movement and invisible strength for the master of espionage',
        pattern: '@d^_wa',
        reps: 9,
        sets: 7,
        focus: 'Silent Power'
    },
    {
        id: 'tokugawa-guardian-conditioning',
        name: 'Tokugawa Guardian Conditioning',
        description: 'Elite protection training for those who guard the most important leaders',
        pattern: 'd@^wa_',
        reps: 11,
        sets: 5,
        focus: 'Elite Protection'
    },
    {
        id: 'iga-province-workout',
        name: 'Iga Province Workout',
        description: 'Traditional ninja conditioning from the legendary Iga mountain region',
        pattern: '^@_dwa',
        reps: 13,
        sets: 4,
        focus: 'Mountain Ninja'
    },
    {
        id: 'invisible-warrior-protocol',
        name: 'Invisible Warrior Protocol',
        description: 'Training to become one with shadows while maintaining lethal effectiveness',
        pattern: 'wa@d^_',
        reps: 7,
        sets: 8,
        focus: 'Shadow Mastery'
    },
    {
        id: 'spymaster-endurance-training',
        name: 'Spymaster Endurance Training',
        description: 'Mental and physical conditioning for long-term infiltration missions',
        pattern: '_^@dwa',
        reps: 17,
        sets: 3,
        focus: 'Mission Endurance'
    },
    {
        id: 'legendary-ninja-mastery',
        name: 'Legendary Ninja Mastery',
        description: 'The ultimate ninja training that created Japan\'s most famous shadow warrior',
        pattern: '@d^_wa!',
        reps: 21,
        sets: 4,
        focus: 'Shadow Legend'
    }
];

// Oda Nobunaga's workout programs
const odaNobunagarPrograms = [
    {
        id: 'demon-lord-training',
        name: 'Demon Lord Training',
        description: 'Ruthless conditioning that mirrors the fierce determination of the great unifier',
        pattern: '$x&*w@',
        reps: 12,
        sets: 3,
        focus: 'Ruthless Power'
    },
    {
        id: 'innovation-warrior-workout',
        name: 'Innovation Warrior Workout',
        description: 'Revolutionary training methods that break traditional samurai conventions',
        pattern: '*$w@x&',
        reps: 14,
        sets: 4,
        focus: 'Revolutionary Strength'
    },
    {
        id: 'unification-protocol',
        name: 'Unification Protocol',
        description: 'All-conquering conditioning for those who seek to unite divided realms',
        pattern: 'w@$*&x',
        reps: 16,
        sets: 3,
        focus: 'Unifying Force'
    },
    {
        id: 'modernization-conditioning',
        name: 'Modernization Conditioning',
        description: 'Forward-thinking training that embraces new technologies and methods',
        pattern: 'x&$w@*',
        reps: 18,
        sets: 4,
        focus: 'Modern Innovation'
    },
    {
        id: 'strategic-dominance-training',
        name: 'Strategic Dominance Training',
        description: 'Multi-dimensional conditioning for total battlefield superiority',
        pattern: '@*$x&w',
        reps: 10,
        sets: 5,
        focus: 'Total Dominance'
    },
    {
        id: 'great-unifier-mastery',
        name: 'Great Unifier Mastery',
        description: 'The complete training regimen of Japan\'s most transformative leader',
        pattern: '$x&*w@!',
        reps: 20,
        sets: 3,
        focus: 'Transformative Leadership'
    }
];

// Tokugawa Ieyasu's workout programs
const tokugawaIeyasuPrograms = [
    {
        id: 'patient-strategist-training',
        name: 'Patient Strategist Training',
        description: 'Methodical conditioning that builds strength through careful long-term planning',
        pattern: '@wd_^a',
        reps: 8,
        sets: 6,
        focus: 'Strategic Patience'
    },
    {
        id: 'shogunate-foundation-workout',
        name: 'Shogunate Foundation Workout',
        description: 'Institution-building strength for those who create lasting governmental power',
        pattern: 'w@_d^a',
        reps: 15,
        sets: 4,
        focus: 'Institutional Power'
    },
    {
        id: 'peace-through-strength-conditioning',
        name: 'Peace Through Strength Conditioning',
        description: 'Balanced training that maintains readiness while promoting stability',
        pattern: 'd@^wa_',
        reps: 12,
        sets: 5,
        focus: 'Peaceful Strength'
    },
    {
        id: 'diplomatic-warrior-protocol',
        name: 'Diplomatic Warrior Protocol',
        description: 'Training that develops both martial prowess and political wisdom',
        pattern: '^_@dwa',
        reps: 11,
        sets: 4,
        focus: 'Diplomatic Power'
    },
    {
        id: 'legacy-builder-training',
        name: 'Legacy Builder Training',
        description: 'Sustainable conditioning designed to last for generations of leadership',
        pattern: 'a@wd^_',
        reps: 14,
        sets: 3,
        focus: 'Generational Legacy'
    },
    {
        id: 'eternal-shogun-mastery',
        name: 'Eternal Shogun Mastery',
        description: 'The complete training system that established centuries of Tokugawa rule',
        pattern: 'w@d^_a!',
        reps: 25,
        sets: 3,
        focus: 'Eternal Leadership'
    }
];

// Main Ancient Japan trainers data object - Group One
const japanOneTrainersData = {
    'tea-master-sen-no-rikyu': {
        id: 'tea-master-sen-no-rikyu',
        name: 'Tea Master Sen no Rikyu',
        specialization: 'Mindful Movement & Balance Specialist',
        image: '/assets/images/tea-master.jpg',
        experience: '70+ years',
        category: 'ancient-japan',
        color: '#8B4513',
        secondaryColor: '#DAA520',
        intro: `Sen no Rikyu perfected the Way of Tea, finding profound beauty in simplicity and mindful movement. His training philosophy emphasizes that every gesture must be purposeful, every breath conscious, and every movement a meditation. Through tea ceremony discipline, he teaches that true strength comes from inner harmony and perfect balance.`,
        programs: teaMasterPrograms
    },
    'kabuki-actor': {
        id: 'kabuki-actor',
        name: 'Kabuki Master',
        specialization: 'Theatrical Athletics & Expression Training',
        image: '/assets/images/kabuki-actor.jpg',
        experience: '40+ years',
        category: 'ancient-japan',
        color: '#DC143C',
        secondaryColor: '#FFD700',
        intro: `The Kabuki Master brings the explosive athleticism of traditional Japanese theater to fitness training. Every movement tells a story, every exercise expresses deep emotion. Through dramatic conditioning, students learn to channel passion into physical power, building both theatrical presence and athletic excellence.`,
        programs: kabukiActorPrograms
    },
    'takeda-shingen': {
        id: 'takeda-shingen',
        name: 'Takeda Shingen',
        specialization: 'Cavalry Leadership & Strategic Conditioning',
        image: '/assets/images/takeda-shingen.jpg',
        experience: '53+ years',
        category: 'ancient-japan',
        color: '#8B0000',
        secondaryColor: '#FFD700',
        intro: `Known as the Tiger of Kai, Takeda Shingen revolutionized mounted warfare through superior conditioning and strategic brilliance. His training develops the core strength needed for mounted combat while building the mental clarity required for battlefield leadership. "Swift as the wind, silent as the forest, fierce as fire, immovable as the mountain."`,
        programs: takedaShingenPrograms
    },
    'hattori-hanzo': {
        id: 'hattori-hanzo',
        name: 'Hattori Hanzo',
        specialization: 'Stealth Conditioning & Shadow Training',
        image: '/assets/images/hattori-hanzo.jpg',
        experience: '55+ years',
        category: 'ancient-japan',
        color: '#2F4F4F',
        secondaryColor: '#C0C0C0',
        intro: `The legendary spymaster who served Tokugawa Ieyasu, Hattori Hanzo perfected the art of invisible strength. His training develops power that doesn't show, speed that leaves no trace, and endurance that outlasts any pursuit. Students learn that true ninja strength comes from becoming one with shadow and silence.`,
        programs: hattoriHanzoPrograms
    },
    'oda-nobunaga': {
        id: 'oda-nobunaga',
        name: 'Oda Nobunaga',
        specialization: 'Revolutionary Warfare & Modernization Training',
        image: '/assets/images/oda-nobunaga.jpg',
        experience: '49+ years',
        category: 'ancient-japan',
        color: '#000000',
        secondaryColor: '#FF4500',
        intro: `The Demon Lord of the Sixth Heaven, Oda Nobunaga destroyed the old order to create something entirely new. His revolutionary training methods break all traditional rules, incorporating new technologies and tactics. Students learn that sometimes you must tear down everything to build something greater.`,
        programs: odaNobunagarPrograms
    },
    'tokugawa-ieyasu': {
        id: 'tokugawa-ieyasu',
        name: 'Tokugawa Ieyasu',
        specialization: 'Strategic Patience & Foundation Building',
        image: '/assets/images/tokugawa-ieyasu.jpg',
        experience: '75+ years',
        category: 'ancient-japan',
        color: '#4B0082',
        secondaryColor: '#FFD700',
        intro: `The founder of the Tokugawa Shogunate, Ieyasu understood that lasting power comes from patient strategy and unshakeable foundations. His training emphasizes sustainable strength, diplomatic flexibility, and the wisdom to know when to strike and when to wait. True victory belongs to those who can endure.`,
        programs: tokugawaIeyasuPrograms
    }
};

// Export the data
export default japanOneTrainersData;